import { render, staticRenderFns } from "./PromoUsers.vue?vue&type=template&id=6998fd0a"
import script from "./PromoUsers.vue?vue&type=script&lang=js"
export * from "./PromoUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports